export default __webpack_public_path__ + "static/media/Jude Dsouza.3a9ffba5.jpg";